import {
  API_BASE_URL,
  API_RELATIVE_PATH,
} from '../../constants/util.constants';
import { Opening } from '../../types/opening.types';
import apiFetch from '../../util/api-fetch';

type FetchOpeningsResult = {
  openings: Opening[];
  page_info: {
    has_next_page: boolean;
    has_previous_page: boolean;
  };
};

const fetchOpenings = async (
  textSearch: string,
  currentPage: number,
): Promise<FetchOpeningsResult | undefined> => {
  let url = `${API_BASE_URL}${API_RELATIVE_PATH}/openings?page=${currentPage}`;

  if (textSearch) {
    url = `${url}&q=${textSearch}`;
  }

  return apiFetch<FetchOpeningsResult>({ url });
};

export default fetchOpenings;
